// src/hooks/usePush.js
import { useEffect } from 'react';
import api from '../utils/api';

export function usePush(currentUser) {
  useEffect(() => {
    if (!currentUser) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const register = async () => {
      try {
        // Register service worker
        const reg = await navigator.serviceWorker.register('/sw.js');

        // Get VAPID public key
        const { data } = await api.get('/push/vapid-key');
        if (!data.publicKey) return; // No key configured yet

        // Check permission
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        // Subscribe
        const sub = await reg.pushManager.subscribe({
          userVisibleOnly:      true,
          applicationServerKey: urlBase64ToUint8Array(data.publicKey),
        });

        // Save to backend
        await api.post('/push/subscribe', {
          subscription: sub.toJSON(),
          userAgent:    navigator.userAgent,
        });
      } catch (err) {
        // Silently fail — push is optional
        console.log('[Push] Not available:', err.message);
      }
    };

    register();
  }, [currentUser?._id]);
}

function urlBase64ToUint8Array(base64String) {
  const padding   = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64    = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData   = window.atob(base64);
  const outputArr = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArr[i] = rawData.charCodeAt(i);
  return outputArr;
}
